import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { RouterModule } from '@angular/router';
import { CaseIncidentTableEntry, CaseStatus } from '../../../../types';
import { ChipColor } from '../../../../components/pan-chip/pan-chip.component';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { getCaseStatusColor, getCaseStatusText } from '../../../../helpers';

@Component({
  selector: 'app-pan-cell-case-tracking-group',
  imports: [UiModule, RouterModule, CommonModule, MatTooltipModule],
  templateUrl: './cell-case-tracking-guest-group.component.html',
  styleUrl: './cell-case-tracking-guest-group.component.scss',
})
export class CellCaseTrackingGuestGroupComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;

  public caseNumber = signal<string>('');
  public locationName = signal<string>('');
  public firstCell = signal<CaseIncidentTableEntry | undefined>(undefined);

  agInit(params: ICellRendererParams) {
    this.params = params;
    const [caseNumber, locationName] = params.value.split('@');
    this.caseNumber.set(caseNumber.trim());
    this.locationName.set(locationName.trim());
    this.firstCell.set(params.node.allLeafChildren[0].data);
  }

  refresh(params: ICellRendererParams) {
    this.params = params;
    return true;
  }

  getStatusColor(status: CaseStatus): ChipColor {
    return getCaseStatusColor(status);
  }

  getStatusText(status: CaseStatus): string {
    return getCaseStatusText(status);
  }
}
